module.exports = __webpack_public_path__ + "static/media/Punjab Public Library_Old.a079c20b.jpg";